import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AtendimentoService } from "src/app/services/actions/atendimento.service";
import * as moment from "moment";
import * as OT from "@opentok/client";
import { UserService } from "src/app/services/user.service";
import { ToastrService } from "ngx-toastr";

@Component({
	selector: "app-videocall",
	templateUrl: "./videocall.component.html",
	styleUrls: ["./videocall.component.scss"],
})
export class VideocallComponent implements OnInit {
	codigo;
	atendimento = {};
	profissional = {};
	user = {};
	horaServidor;
	mensagem;
	habilitadoParaVideo = false;
	token;
	sessionId;
	apiKey;
	dataFinalAtendimento;
	dataInicioAtendimento;

	constructor(
		private route: ActivatedRoute,
		private atendimentoService: AtendimentoService,
		private userService: UserService,
		private toastr: ToastrService
	) {}

	ngOnInit() {
		this.route.params.subscribe((params) => {
			this.codigo = params["codigo"];

			this.atendimentoService.getVideocall(this.codigo).subscribe(
				(res) => {
					this.atendimento = res["atendimento"];
					this.dataFinalAtendimento = moment(
						this.atendimento["date"]
					).add(1, "hours");
					this.dataInicioAtendimento = moment(
						this.atendimento["date"]
					);
					this.profissional = res["profissional"];
					this.user = res["user"];

					this.sessionId = this.atendimento["sessionId"];
					this.token = res["videocall"].token;
					this.apiKey = res["videocall"].apiKey;

					this.userService.getHoraServidor().subscribe((res) => {
						this.horaServidor = res;

						this.verificarAtendimento();
					});
				},
				(err) => {
					this.mensagem = err.error + "";
				}
			);
		});
	}

	verificarAtendimento() {
		this.habilitadoParaVideo = true;
		this.iniciarVideochamada();
	}

	iniciarVideochamada() {
		if (this.sessionId && this.token && this.apiKey) {
			var session = OT.initSession(this.apiKey, this.sessionId);

			session.on("streamCreated", (event) => {
				session.subscribe(event.stream, "subscriberContainer", {
					insertMode: "append",
					width: 500,
					height: 500,
				});
				console.log(event);
			});

			var publisher = OT.initPublisher("publisherContainer", {
				width: 500,
				height: 500,
			});

			session.connect(this.token, (error) => {
				// If the connection is successful, publish to the session
				if (error) {
					console.log(error);
				} else {
					session.publish(publisher, (a) => {
						console.log(a);
						console.log("ae");
					});
					console.log(publisher);
				}
			});
		} else {
			this.toastr.error(
				"Não foi possível se conectar com a sessão",
				"Erro"
			);
		}
	}
}
